module.exports = __webpack_public_path__ + "img/loading_img.15584684.png";